import { Component } from '@angular/core';
import { SharedModule } from 'src/app/shared';

@Component({
  selector: 'app-data-protection',
  imports: [SharedModule],
  templateUrl: './data-protection.component.html',
  styleUrl: './data-protection.component.scss'
})
export class DataProtectionComponent {

}
